import React, { useState } from 'react';
import './App.css';

// Importem els components modularitzats
import TaskForm from './components/TaskForm';
import TaskList from './components/TaskList';

function App() {
  // Estat inicial de les tasques (ara amb dueDate)
  const [tasks, setTasks] = useState([
    { id: 1, text: 'Comprar pa', completed: false, dueDate: null },
    { id: 2, text: 'Acabar informe', completed: true, dueDate: new Date().toISOString() },
  ]);

  // Afegir una nova tasca
  const handleAddTask = (text) => {
    const task = {
      id: Date.now(),
      text: text,
      completed: false,
      dueDate: null, // camp per la data límit
    };
    setTasks([...tasks, task]);
  };

  // Marcar o desmarcar una tasca com a completada
  const handleToggleComplete = (taskId) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId ? { ...task, completed: !task.completed } : task
      )
    );
  };

  // Eliminar una tasca
  const handleDeleteTask = (taskId) => {
    setTasks(tasks.filter((task) => task.id !== taskId));
  };

  // Actualitzar només la data d'una tasca
  const handleUpdateTaskDate = (taskId, newDate) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId
          ? { ...task, dueDate: newDate ? newDate.toISOString() : null }
          : task
      )
    );
  };

  return (
    <div className="app-container">
      <div className="todo-container">
        <h1>La Meva Llista de Tasques</h1>

        {/* Formulari separat per afegir tasques */}
        <TaskForm onAddTask={handleAddTask} />

        {/* Llista de tasques modularitzada */}
        <TaskList
          tasks={tasks}
          onToggleComplete={handleToggleComplete}
          onDeleteTask={handleDeleteTask}
          onUpdateTaskDate={handleUpdateTaskDate}
        />
      </div>
    </div>
  );
}

export default App;